import ReactDOM from "react-dom/client";
import { App } from "./App";

/** Make sure to let users know under a specific media query that the mobile version is still being worked on */

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);